module.exports = __webpack_public_path__ + "static/media/convidados-contatos.0937786d.png";